import { AccessibleSortMsg } from "components/common/accessible-sort-msg";
import styles from "../style.module.scss";
import { TableToolTip } from "../tooltip";
import { TableTitleProps } from "utils/Types";

export default function TableTitle({
  sortOrder,
  title,
  altText,
  tooltipTitle,
  iconColor = "black"
}: TableTitleProps) {
  return (
    <span className={styles["align-vertically"]}>
      <div style={{ marginRight: 8 }}>{title}</div>
      <TableToolTip iconColor={iconColor} title={tooltipTitle} altText={altText ?? ""} />
      {sortOrder ? <AccessibleSortMsg sortOrder={sortOrder} /> : null}
    </span>
  );
}
